import React, { useState } from "react";

import Navigation from "../components/Navigation";
import Header from "../components/Header";
import Project from "../components/Project";
import AboutMe from "../components/AboutMe";
import ContactMe from "../components/ContactMe";
import Resume from "../components/Resume";
import Footer from "../components/Footer";
import Screenshot1 from "../images/p1-1_LIVE.png";
import MailSeeds from "../images/Mail-Seeds.png";
import JATE from "../images/JATE.png";
import HackerFit from "../images/HackerFit.png";
import RPSGame from "../images/RPSGame.png";
import SPED from "../images/SPED-Planner.png"

function Container() {
  const [currentPage, setCurrentPage] = useState("AboutMe");
  // this is the function that renders components (pages)
  const renderPage = () => {
    if (currentPage === "AboutMe") {
      return (
        <div className="quickBorder">
          <AboutMe />
        </div>
      );
    }
    if (currentPage === "Project") {
      return (
        <div className="flexThis">
          <Project
            name="Mail-Me-Seeds"
            src={MailSeeds}
            href="https://mail-me-seeds.herokuapp.com/"
            description="The idea behind Mail-Me-Seeds was so avid gardeners could trade and collect various seeds for their hobby. This project was a large take on for our group of 4 including myself, and as always, it seemed like a simple approach, but as our needs for new interactions grew, so did the application. We were able to apply a password reset feature by using the Node-mailer package, along with the ability for users to send requests to each other for various seeds!"
            github="https://github.com/TheBluWiz/mail-me-seeds"
          />

          <Project
            name="Gif-Me-That-Movie"
            src={Screenshot1}
            href=""
            description="A fun application that will give you information based on when the movie was made, by whom, etc. It will also present some various 'gifs' from the movie you searched for! This was the first Group project I was involved with and was mainly incharge of adding the Bulma CSS Framework to our application."
            github="https://github.com/MaksimRazuvaev/funny_movie_gif"
          />

          <Project name="JATE" src={JATE} href="https://text-editor-sinzostyle.herokuapp.com/" description="This is a simple little text-editor that can save your entires for later use as whether or not you have online access or not at the time. It is a PWA." github="https://github.com/MrSinzo/Text_Editor_SinzoStyle"/>

          <Project name="HackerFIt" src={HackerFit} href="https://young-fjord-19401.herokuapp.com/" description="This is my first Full-Stack Application Group project. This projects goals were to allow a user to create a profile and list of exercises generated by an API and save them for future reference. There were a lot of learing curves creating this application, and It seemed to just get more complicated as we built it." github="https://github.com/mtownsend509/HackerFit"/>

          <Project name="SPED-Planner" src={SPED} href="https://mrsinzo.github.io/Sinzos-Daily-Planner/" description="Very easy to use application meant for Elementary Classroom Teachers. This app allows the user to create a quick schedule for the day and add the 'activities' to an list that they can drag around the screen. Having draggable aspect was the main approach since the kids would be the target user for this application. The Teacher creates an activity and the kids can drag it on a smart board from the list into 'Current Activity', and when the activity is done, they would drag it into the 'All Done!' section." github="https://github.com/MrSinzo/Sinzos-Daily-Planner"/>

          <Project
            name="Rock-Paper-Scissors"
            src={RPSGame}
            href="https://mrsinzo.github.io/Sinzos-RPS-Game/"

            description="Here is a very simple application ran on your browser to play rock-paper-scissors with an AI and keep track of your score! This little project was a MAJOR learning curve for me in my early days of learning JavaScript. I was just getting use to HTML and CSS syntax and then being introduced to Javascript so shortly after was quite a shock."
            github="https://github.com/MrSinzo/Sinzos-RPS-Game"
          />
        </div>
      );
    }
    if (currentPage === "ContactMe") {
      return <div className="quickBorder"><ContactMe /></div>;
    }
    if (currentPage === "Resume") {
      return <div className="quickBorder"><Resume /></div>;
    }
  };

  const handlePageChange = (page) => setCurrentPage(page);

  return (
    <div>
      <Header />
      <Navigation
        currentPage={currentPage}
        handlePageChange={handlePageChange}
      />
      {renderPage()}
      <Footer />
    </div>
  );
}

export default Container;
